import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { ECollectionPageType } from '@src/pages/[...slug]/components/collection/services/collectionService/CollectionService.types'
// @i18n-ignore-file
import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import { getSeoMetapageData } from '@src/quince-site-common/src/utils/seo/getSeoMetadata'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { fetchRegionDetails } from '@src/server-side/api/fetch-region-details'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'
import {
  CollectionServerSideFeatureFlags,
  FEATURE_FLAG_TYPE,
  FILTER_TYPE,
  URL_PLACEMENT,
} from '@src/server-side/server-feature-flags/feature-flag.types'
import { isUserAgnosticFeatureGateEnabled } from '@src/server-side/server-side-statsig/user-agnostic-feature-gate.server'
import { negotiateLocale } from '@src/server-side/utils/server-props.utils'

import { CollectionFeatureProvider } from '../[...slug]/components/collection/collection-feature-provider'
import Layout from '../layout'

import SearchPage from './search-page'

export const DEFAULT_FEATURE_FLAGS_FOR_SEARCH: CollectionServerSideFeatureFlags = {
  featureFlagType: FEATURE_FLAG_TYPE.COLLECTION,
  subCollectionUrlPlacement: URL_PLACEMENT.PATH,
  collectionPageType: ECollectionPageType.GROUPED,
  filterType: FILTER_TYPE.DROPDOWN,
  isDynamicCollection: false,
  bestSellerExperimentBucket: null,
  clpPersonalisationExperimentBucket: null,
  velouFiltersExperimentBucket: null,
  isBestSellerPersonalizedExp: false,
  isPersonalized: false,
}

const SLUG = 'search'
const SEO_TITLE = 'Search'
const SEO_DESCRIPTION = 'Search items from Quince'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.SEARCH)

  // Safe access to isI18nPreviewEnabled with fallback
  const isI18nPreviewEnabled =
    'props' in serverSideBaseProps ? (await serverSideBaseProps.props).isI18nPreviewEnabled : false

  const regionDetails = await fetchRegionDetails({ isI18nPreviewEnabled })
  const { locale } = negotiateLocale(ctx, regionDetails, isI18nPreviewEnabled)
  // eslint-disable-next-line i18next/no-literal-string
  const isAppendQuinceLocale = await isUserAgnosticFeatureGateEnabled('seo-title-append-quince-locale', false, {
    locale: locale,
  })
  if ('props' in serverSideBaseProps) {
    const props = await serverSideBaseProps.props
    /* eslint-disable i18next/no-literal-string */
    return {
      props: {
        ...props,
        seoMetaData: getSeoMetapageData(
          props.isI18nPreviewEnabled,
          {
            slug: SLUG,
            seoTitle: SEO_TITLE,
            seoDescription: SEO_DESCRIPTION,
          },
          locale,
          regionDetails,
          isAppendQuinceLocale,
          false,
        ),
      },
    }
    /* eslint-enable i18next/no-literal-string */
  }
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function PageSearch(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      <CollectionFeatureProvider serverSideFeatureFlags={DEFAULT_FEATURE_FLAGS_FOR_SEARCH}>
        <SearchPage />
      </CollectionFeatureProvider>
    </Layout>
  )
}
